import { createContext, useContext } from "react";

export const CONTENT_MODAL_TYPE = {
  GALLERY: "gallery",
  CREATE_WITH_IA: "createWithIA",
  SHARE: "share",
};

export const ContentModalsContext = createContext(null);

export const useContentModals = () => {
  const value = useContext(ContentModalsContext);
  if (!value) {
    throw new Error(
      "useContentModals must be used within ContentModalsProvider"
    );
  }
  return value;
};
